// Country to currency mapping (example for a few countries)
const countryCurrencyMap = {
  US: 'USD', // United States → USD
  AU: 'AUD', // Australia → AUD
  CA: 'CAD', // Canada → CAD
}

// Detect the user's country using Geolocation API
function getUserLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      setCurrencyBasedOnLocation,
      handleGeolocationError
    )
  } else {
    alert('Geolocation is not supported by this browser.')
  }
}

// Set the default currency based on the user's country
function setCurrencyBasedOnLocation(position) {
  const countryCode = position.coords.country // Get the country code from the geolocation data
  const currency = countryCurrencyMap[countryCode] || 'USD' // Default to USD if no match

  updateCurrencyButton(currency)
}

// Handle geolocation errors (e.g., user denies permission)
function handleGeolocationError(error) {
  console.error('Geolocation error:', error)
  updateCurrencyButton('USD') // Default to USD if geolocation fails
}

function updateCurrencyButton(currency) {
  const currencyBtn = document.getElementById('currency-btn')
  const flag = currencyBtn.querySelector('.flag') // Select the existing flag element
  const dropdownLinks = document.querySelectorAll('.dropdown-content a')

  // Update the text for the selected currency
  let currencyText = ''
  dropdownLinks.forEach((link) => {
    if (link.getAttribute('data-currency') === currency) {
      currencyText = link.textContent
    }
  })

  // Update the flag's data-currency attribute
  if (flag) {
    flag.setAttribute('data-currency', currency)
  }

  // Update the button text while preserving the flag
  const caret = currencyBtn.querySelector('.caret') // Select the existing caret
  const textNode = document.createTextNode(` ${currencyText} `)

  // Clear everything except the flag and caret
  while (currencyBtn.firstChild) {
    if (currencyBtn.firstChild === flag || currencyBtn.firstChild === caret) {
      currencyBtn.removeChild(currencyBtn.firstChild)
    } else {
      currencyBtn.firstChild.remove()
    }
  }

  // Add the text node back and re-append the caret
  currencyBtn.insertBefore(flag, caret)
  currencyBtn.insertBefore(textNode, caret)
}

// Initialize and get the user's location
getUserLocation()

// Currency change logic (when the user selects a currency)
const dropdownLinks = document.querySelectorAll('.dropdown-content a')
dropdownLinks.forEach((link) => {
  link.addEventListener('click', (event) => {
    const selectedCurrency = event.target.getAttribute('data-currency')
    const currencyText = event.target.textContent
    const currencyBtn = document.getElementById('currency-btn')

    currencyBtn.innerHTML = `${currencyText} <span class="caret">&#9660;</span>` // Update the button text
    dropdownLinks.forEach((link) => link.classList.remove('selected')) // Clear previous selections
    event.target.classList.add('selected') // Highlight selected currency
  })
})

// Close the dropdown if clicked outside
document.addEventListener('click', (event) => {
  const dropdown = document.querySelector('.dropdown')
  if (!dropdown.contains(event.target)) {
    document.querySelector('.dropdown-content').style.display = 'none'
  }
})
